import { InitialStopFormValues } from './types';

export const initialFormValues: Partial<InitialStopFormValues> = {
  locationName: '',
  timeAppointment: '',
  dateAppointment: '',
  appointmentNum: '',
  needsAppointment: false,
  appointmentSchedulingStatus: '',
  aiSchedulingEnabled: false,
  appointmentPreference: '',
  address1: '',
  address2: '',
  countryCode: 'USA',
  description: '',
  directions: '',
  instructions: '',
  city: '',
  state: '',
  zip: '',
  contact: '',
  phone: '',
  email: '',
  time: '',
  referenceNum: '',
  stopDateTime: '',
  driverDateIn: '',
  driverDateOut: '',
  driverTimeIn: '',
  driverTimeOut: '',
  loadItems: [],
  mode: '',
  pickUp: true,
  dropOff: false,
  stopCode: '',
  id: 0,
  operationType: 'Insert',
  driverInTimeZone: '',
  driverOutTimeZone: '',
  appointmentTimeZone: '',
  proprietaryCode: '',
  shouldSendEdiBooleanVals: {
    shouldSendPickupAppointmentAuto214: false,
    shouldSendDropoffAppointmentAuto214: false,
    shouldSendDropoffDriverInAuto214: false,
    shouldSendPickupDriverInAuto214: false,
    shouldSendPickupDriverOutAuto214: false,
    shouldSendDropoffDriverOutAuto214: false,
  },
  timezone: '',
  dropTrailer: false,
};

export const appointmentSchedulingStatusOptions = [
  { label: 'Required', value: 'Required' },
  { label: 'Ready to Schedule', value: 'ReadyToSchedule' },
  { label: 'Appointment Requested', value: 'AppointmentRequested' },
  { label: 'Appointment Confirmed', value: 'AppointmentConfirmed' },
];

export const defaultLoadItems = {
  operationType: 'Insert',
  id: 0,
  ltlQuoteLoadItemId: undefined,
  loadId: 0,
  nmfc: undefined,
  class: null,
  item: 'Items',
  description: '',
  quantity: 1,
  charge: undefined,
  pickUpId: null,
  dropOffId: null,
  weight: null,
  uom: 'lbs',
  volume: undefined,
  hazmat: false,
  heightInch: undefined,
  lengthInch: undefined,
  widthInch: undefined,
  height: undefined,
  length: undefined,
  width: undefined,
  pieces: 1,
  descriptionWithParanthesis: '',
  displayDimensions: '',
  loadItemHazmatDetail: undefined,
};
